import axios from "axios";

export const apiGetMeeting = async (id, tz) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/record/${id}?tz=${tz}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMeeting");
    console.log(error);
    return null;
  }
};

export const apiGetMeetingBuild = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/build/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMeetingBuild");
    console.log(error);
    return null;
  }
};

export const apiGetMeetingBuildV2 = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/buildv2/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMeetingBuild");
    console.log(error);
    return null;
  }
};

export const apiGetMinutesDraft = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/draft/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetMinutesDraft");
    console.log(error);
    return null;
  }
};

export const apiSaveMeeting = async (data, id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .put(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/record/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiSaveMeeting");
    console.log(error);
    return null;
  }
};

export const apiGenerateMinutesDraft = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/minutes-draft`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { url } = response.data;
          return url;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGenerateMinutesDraft");
    console.log(error);
    return null;
  }
};

export const apiGetLinkableMinutes = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/minutes-draft?client=${data.client}&dep=${data.dep}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetLinkableMinutes");
    console.log(error);
    return null;
  }
};

export const apiLinkMinutes = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .put(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/minutes-link`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiLinkMinutes");
    console.log(error);
    return null;
  }
};

export const apiCheckInProgress = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/inprogress/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiCheckInProgress");
    console.log(error);
    return null;
  }
};

export const apiGenerateMinutesPdf = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/minutes`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { url } = response.data;
          return url;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGenerateMinutesDraft");
    console.log(error);
    return null;
  }
};

export const apiUpdateRollCall = async (data, type) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/rollcall?type=${type}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiUpdateRollCall");
    console.log(error);
    return null;
  }
};

export const apiUpdateCoverSheet = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/cover/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiUpdateCoverSheet");
    console.log(error);
    return null;
  }
};

export const apiSignageCheck = async (client, room) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/signage/${client}?room=${room}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiCheckInProgress");
    console.log(error);
    return null;
  }
};

export const apiGetSupplemental = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/supplemental/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetSupplemental");
    console.log(error);
    return null;
  }
};

export const apiUpdateSupplemental = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/supplemental/${id}`,
        data,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiUpdateSupplemental");
    console.log(error);
    return null;
  }
};

export const apiGetCancellation = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/cancellation/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetCancellation");
    console.log(error);
    return null;
  }
};

export const apiGetCancelNotice = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/notice/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetCancelNotice");
    console.log(error);
    return null;
  }
};

export const apiUpdateMeeting = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .put(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/minutes/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          if (Object.keys(response.data).length > 0) {
            return response.data;
          } else {
            return true;
          }
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiUpdateMeeting");
    console.log(error);
    return null;
  }
};

export const apiGetSpecificMinutes = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/minutes/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGetSpecificMinutes");
    console.log(error);
    return null;
  }
};

export const apiGenerateCoverSheet = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/cover-sheet`,
        { id: id },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { url } = response.data;
          return url;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGenerateCoverSheet");
    console.log(error);
    return null;
  }
};

export const apiGeneratePacket = async (id, email) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/pdf/packet/${id}?email=${email}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiGeneratePacket");
    console.log(error);
    return null;
  }
};

export const apiImportTopics = async (
  session,
  topics,
  client,
  user,
  department,
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/import/${session}`,
        { topics, clientId: client, user: user, department },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiImportTopics");
    console.log(error);
    return null;
  }
};

export const apiImportLegistarTopics = async (
  session,
  topics,
  client,
  user,
  board,
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/legistar/${session}`,
        { topics, clientId: client, user: user, board: board },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiImportTopics");
    console.log(error);
    return null;
  }
};

export const apiImportHarbourTopics = async (
  session,
  topics,
  client,
  user,
  board,
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/topics/harbour/${session}`,
        { topics, clientId: client, user: user, board: board },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiImportTopics");
    console.log(error);
    return null;
  }
};

export const apiDeleteMeeting = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/delete/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiDeleteMeeting");
    console.log(error);
    return null;
  }
};

export const apiStartMeeting = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/live/${id}`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiStartMeeting");
    console.log(error);
    return null;
  }
};

export const apiCreateNewMeeting = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/new`,
        { ...data },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api session apiCreateNewMeeting");
    console.log(error);
    return null;
  }
};
